<template>
  <div class="wrapper-bar-4">
    <div class="grid">
      <router-link
        :to="
          $i18nRoute({
            name: 'NewsDetail',
            params: { slug: item.url }
          })
        "
        v-for="(item, index) in list.slice(0, 12)"
        :key="item.id"
        class="grid__item"
      >
        <div class="card" :class="`card-${index + 1}`">
          <div class="card__category-desctop">
            {{ item.sub_category.name }}
          </div>
          <div class="flex-desctop flex-mobile">
            <div class="card__img">
              <div class="card__category">{{ item.sub_category.name }}</div>
              <ImageContainer
                :src="item.image.medium"
                :thumb="item.image.thumbnail"
                :alt="item.title"
              />
              <i v-if="item.video" class="fas fa-play-circle icon-player"></i>
            </div>
            <div class="card__descr">
              <div class="card__title limited-text">{{ item.title }}</div>
              <div class="data-news">
                <span class="day">{{ handleDate(item.pub_date) }},</span>
                <span class="time">{{ handleTime(item.pub_date) }}</span>
              </div>
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
export default {
  components: { ImageContainer },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>

<style lang="scss" scoped>
.wrapper-bar-4 {
  width: 100%;
  padding: 5rem 0;
  @media screen and (max-width: 992px) {
    padding: 2rem 0;
  }
  @media screen and (max-width: 767px) {
    padding: 1rem 0;
  }
}
.card {
  &__title {
    // margin-top: 0.5rem;
    font-family: Roboto;

    font-weight: 400;
    font-size: calc(min(1.25em, 1vw));
    line-height: 1.3em;
    @media screen and (max-width: 1100px) {
      font-size: calc(min(1.25em, 1.3vw));
    }
    @media screen and (max-width: 992px) {
      font-family: Roboto;
      font-style: normal;
      font-size: 16px;
      line-height: 22px;
    }
    @media screen and (max-width: 767px) {
      font-family: Roboto;

      font-size: 12px;
      line-height: 15px;
      color: var(--primary-font-color);
    }
  }
  .data-news {
    font-family: Open Sans;
    font-size: calc(min(0.9em, 0.85vw));
    line-height: 19px;
    margin-top: 8px;
    @media screen and (max-width: 992px) {
      font-family: Open Sans;
      font-size: 13px;
      line-height: 18px;
      color: var(--category-color);
    }
    @media screen and (max-width: 767px) {
      font-family: Open Sans;
      font-size: 10px;
      line-height: 14px;

      // color: rgba(255, 255, 255, 0.6);
    }
  }
  &__img {
    position: relative;
    border-radius: 4px;
    overflow: hidden;
  }
  &__category {
    position: absolute;
    z-index: 3;
    font-family: Open Sans;
    font-size: 16px;
    line-height: 22px;
    color: var(--category-color);
    background: var(--background-color);
    padding: 3px;
    @media screen and (max-width: 992px) {
      font-family: Open Sans;
      font-weight: 600;
      font-size: 13px;
      line-height: 18px;
      text-transform: uppercase;
    }
    @media screen and (max-width: 767px) {
      font-family: Open Sans;
      font-weight: 600;
      font-size: 10px;
      line-height: 14px;
    }
  }
}
.card__category-desctop {
  font-family: Open Sans;
  font-size: 1em;
  line-height: 22px;
  color: var(--category-color);
  @media screen and (max-width: 992px) {
    display: none;
  }
}

.flex-desctop {
  display: flex;
  gap: 0.8rem;
  @media screen and (max-width: 992px) {
    display: block;
  }
}
.flex-mobile {
  @media screen and (max-width: 767px) {
    display: flex;
  }
}
.grid {
  max-width: clamp(375px, 100%, 2560px);
  margin: 0 auto;
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(8, 1fr);
  gap: 1.1rem;
  &__item {
    grid-column: span 2;
  }
  &__item:nth-child(1) {
    grid-row: span 4;
    // margin-top: ;
  }
  &__item:nth-child(2) {
    grid-column: 3 / span 2;
  }
  &__item:nth-child(3) {
    grid-column: 5 / span 2;
    grid-row: span 4;
    // margin-top: ;
  }
  &__item:nth-child(4) {
    grid-column: 3 / span 2;
  }
  &__item:nth-child(5) {
    grid-column: 3 / span 2;
  }
  &__item:nth-child(6) {
    grid-column: 3 / span 2;
  }
  &__item:nth-child(7) {
    grid-column: 3 / span 2;
  }
  &__item:nth-child(8) {
    grid-column: 1 / span 2;
    grid-row: 5 / span 4;
    // margin-top: ;
  }
  &__item:nth-child(9) {
    grid-column: 3 / span 2;
  }
  &__item:nth-child(10) {
    grid-column: 3 / span 2;
  }
  &__item:nth-child(11) {
    grid-column: 3 / span 2;
  }
  &__item:nth-child(12) {
    grid-column: 5 / span 2;
    grid-row: 5 / span 4;
    // margin-top: ;
  }
  .card-1,
  .card-3,
  .card-8,
  .card-12 {
    width: 78%;
    .card__category-desctop {
      display: none;
    }
    .flex-desctop {
      flex-direction: column;
    }
    .card__img {
      height: 13vw;
      width: 100%;
    }
    @media screen and (max-width: 992px) {
      .card__img {
        height: 125px;
      }
    }
  }
  .card-1,
  .card-8 {
    .card__descr {
      margin-left: 1rem;
    }
  }
  .card-1,
  .card-3 {
    margin-top: 6rem;
  }
  .card-3,
  .card-12 {
    margin-left: auto;
  }
  .card-8,
  .card-12 {
    margin-top: 3rem;
  }
  .card-2,
  .card-4,
  .card-5,
  .card-6,
  .card-7,
  .card-9,
  .card-10,
  .card-11 {
    // padding: 0 0.5rem;
    .card__category {
      display: none;
    }
    .card__img {
      height: 4.15vw;
      min-height: 88px;
      flex: 0 0 25%;
    }
    @media screen and (max-width: 992px) {
      .card__img {
        height: 125px;
      }
    }
  }
}
@media screen and (max-width: 992px) {
  .grid {
    grid-template-rows: auto;
    gap: 0;

    &__item:nth-child(1) {
      grid-row: auto;
      // margin-top: ;
    }
    &__item:nth-child(2) {
      grid-column: 3 / span 2;
    }
    &__item:nth-child(3) {
      grid-column: 5 / span 2;
      grid-row: auto;
      // margin-top: ;
    }
    &__item:nth-child(4) {
      grid-column: 1 / span 2;
    }
    &__item:nth-child(5) {
      grid-column: 3 / span 2;
    }
    &__item:nth-child(6) {
      grid-column: 5 / span 2;
    }
    &__item:nth-child(7) {
      grid-column: 1 / span 2;
    }
    &__item:nth-child(8) {
      grid-column: 3 / span 2;
      grid-row: auto;
      // margin-top: ;
    }
    &__item:nth-child(9) {
      grid-column: 5 / span 2;
    }
    &__item:nth-child(10) {
      grid-column: 1 / span 2;
    }
    &__item:nth-child(11) {
      grid-column: 3 / span 2;
    }
    &__item:nth-child(12) {
      grid-column: 5 / span 2;
      grid-row: auto;
      // margin-top: ;
    }
  }
  .card {
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
    height: auto !important;
    padding: 1.39rem !important;

    .card__img {
      height: 125px;
    }
    .card__descr {
      margin: 0 !important;
    }
    .card__title {
      margin-top: 0.5rem;
    }
    .card__category {
      display: block !important;
    }
  }
  .card-1,
  .card-4,
  .card-5,
  .card-7,
  .card-8,
  .card-9,
  .card-10,
  .card-11,
  .card-12 {
    min-height: 100%;
    background-color: #fff;
    color: var(--black-text);
    .card__category {
      background-color: #fff;
    }
  }
}

@media screen and (max-width: 767px) {
  .grid {
    display: block;
  }
  .card-1,
  .card-4,
  .card-5,
  .card-7,
  .card-8,
  .card-9,
  .card-10,
  .card-11,
  .card-12 {
    min-height: 100%;
    background-color: transparent;
    color: inherit;
    .card__category {
      background-color: inherit;
    }
  }
  .card {
    padding: 0.7rem 1rem !important;
    .flex-mobile {
      gap: 0.5rem;
      display: flex;
      flex-direction: row !important;
    }
    &__img {
      flex: 0 0 47% !important;
      height: 90px !important;
    }
    &__title {
      margin-top: 0 !important;
    }
    &__category {
      background-color: var(--background-color) !important;
    }
    &__descr {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
  .card-5,
  .card-6,
  .card-7,
  .card-8 {
    padding: 0.7rem 10px !important;

    .flex-mobile {
      flex-direction: row-reverse !important;
      .card__descr {
        text-align: right;
      }
    }
  }
}
.icon-player {
  position: absolute;
  bottom: 10px;
  left: 10px;
  font-size: 1.2rem;
  color: #fff;
}
</style>
